import { http } from '@/shared/api';

/**
 * API для управления сессией
 */

/**
 * Выход из системы
 */
export interface LogoutResult {
  isLogout: boolean;
  impersonationStopped: boolean;
}

export async function logout(): Promise<LogoutResult> {
  const response = await http.post<LogoutResult>('/api/v2/auth/logout');

  return response.data;
}
